export default "__VITE_ASSET__a9021683__"